import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserPlus, UserCheck } from "lucide-react";
import { api, formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export function FollowButton({ chefId, initialFollowing, initialCount, onChange, size = "md" }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [following, setFollowing] = useState(!!initialFollowing);
  const [count, setCount] = useState(initialCount || 0);
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    if (!user) { toast("Log in to follow chefs"); navigate("/login"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/chefs/${chefId}/follow`);
      setFollowing(data.following); setCount(data.followers_count);
      onChange?.(data);
      toast.success(data.following ? "You're now following this chef" : "Unfollowed");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  const h = size === "sm" ? "h-10 px-4 text-sm" : "h-12 px-6";
  return (
    <button onClick={toggle} disabled={busy} data-testid="follow-button" aria-pressed={following}
      className={`inline-flex items-center gap-2 rounded-full font-bold transition-colors disabled:opacity-60 ${h} ${
        following ? "bg-white border border-border text-ink hover:border-coral" : "bg-coral hover:bg-coral-hover text-white"}`}>
      {following ? <UserCheck size={18} /> : <UserPlus size={18} />}
      {following ? "Following" : "Follow"}
      <span className={`text-xs font-black rounded-full px-2 py-0.5 ${following ? "bg-secondary text-ink-soft" : "bg-white/20"}`} data-testid="followers-count">{count}</span>
    </button>
  );
}
